module.exports = __webpack_public_path__ + "static/img/content_1.20a0548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/who_are_we/content_1.png
// module id = yIQu
// module chunks = 94